import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/detail/${article.movieId}`}
      className="group flex flex-col rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors overflow-hidden cursor-pointer"
    >
      <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title}配图`}
          title={`${article.title} - ${article.movieTitle}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-secondary-950 text-xs font-label font-semibold">
          {article.keyword}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm font-label text-foreground-600 line-clamp-2">{article.summary}</p>
        <div className="mt-auto pt-3 flex items-center justify-between text-xs font-label text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-movie-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {article.movieTitle}
          </span>
          <span>{article.date}</span>
        </div>
      </div>
    </Link>
  );
}